/**
 * Rodzaj celu pozycji panelu „Wymaga uwagi” — wyznacza napis odsyłacza.
 * Sam adres składa front z klucza sprawy literałem trasy (`attentionLinks.ts`).
 */
export enum AttentionTarget {
  FINANCES = 'FINANCES',
  BUDGET = 'BUDGET',
  WAITLIST = 'WAITLIST',
  MESSAGES = 'MESSAGES',
  PARTICIPANTS = 'PARTICIPANTS',
  OPTIONS = 'OPTIONS',
  /** Konfiguracja wyjazdu — limit miejsc, okno zapisów, raty; spoza zakładek ekranu. */
  TOUR_SETTINGS = 'TOUR_SETTINGS',
  /** Ustawienia firmy — nadawca, TPay. */
  SETTINGS = 'SETTINGS',
  /** Dostęp i zaproszenia. */
  ACCESS = 'ACCESS',
  /** Umowy i zgody. */
  CONSENTS = 'CONSENTS',
  /** Paczki zmian rezerwacji. */
  CHANGES = 'CHANGES',
  /** Kody promocyjne. */
  DISCOUNTS = 'DISCOUNTS',
  /** Ekran TFG. */
  TFG = 'TFG',
  /** Konfiguracja transportu wyjazdu. */
  TRANSPORT = 'TRANSPORT',
  /** Zapisujący wyjazdu. */
  CLIENTS = 'CLIENTS',
  /** Podsumowanie wyjazdu. */
  TOUR = 'TOUR',
}
